// extracted by mini-css-extract-plugin
export default {"imageWrapper":"eG-z","twoColumnImage":"fG-z"};